import { inject, type Ref, computed } from 'vue';
import { StackedViewParentInjectionKey } from '../Services/StackedView';
import type { StackedViewResolved } from '../Types/StackedView';
import { useUrlGenerator } from '../Services/UrlGenerator.ts';

export function useViewParent(): Ref<StackedViewResolved | undefined> {
  const view = inject(StackedViewParentInjectionKey);

  if (!view) {
    throw new Error('You\'re trying to get parent view out of Router context!');
  }

  return view;
}

export function useViewParentLocation() {
  const parent = useViewParent();
  const url = useUrlGenerator();

  return computed(() => {
    if (parent && parent.value && parent.value.location) {
      return url.generate(parent.value.location, parent.value.query);
    }
  });
}
